module.exports = __webpack_public_path__ + "img/logo-white-horizontal.1ef99c99.svg";